import { Form, Input, Button, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import DateRangePicker from 'components/antdCustom/DateRangePicker';

const FilterBar = (props) => {
  const { t } = useTranslation();
  const { loading } = props;
  return (
    <Form layout='horizontal' colon={false} onFinish={props.onChange}>
      <Row gutter={8}>
        <Col className='gutter-row' xs={12} md={6} xl={4}>
          <Form.Item name='id'>
            <Input placeholder={t('transactionId')} allowClear />
          </Form.Item>
        </Col>
        <Col className='gutter-row' xs={12} md={6} xl={4}>
          <Form.Item name='clientName'>
            <Input placeholder={t('customerName')} allowClear />
          </Form.Item>
        </Col>
        <Col className='gutter-row' xs={12} md={6} xl={4}>
          <Form.Item name='clientPhone'>
            <Input placeholder={t('phoneNumber')} allowClear />
          </Form.Item>
        </Col>
        <Col className='gutter-row' xs={12} md={6} xl={4}>
          <Form.Item name='dateRange'>
            <DateRangePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col className='gutter-row' xs={12} md={6} xl={4}>
          <Form.Item>
            <Button
              block
              type='primary'
              htmlType='submit'
              loading={loading}
              icon={<SearchOutlined />}>
              {t('search')}
            </Button>
          </Form.Item>
        </Col>
        <Col className='gutter-row' xs={12} md={6} xl={4}>
          <Form.Item noStyle shouldUpdate>
            {(form) => {
              return (
                <Button
                  block
                  onClick={() => form.resetFields()}
                  icon={<ReloadOutlined />}>
                  {t('resetFilter')}
                </Button>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default FilterBar;
